module.exports = __webpack_public_path__ + "assets/img/1_1703.68798b21.jpg";